import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { NgClass } from '@angular/common';
import { TranslatePipe } from '@skylab-angular-shared/pipes';
import { ButtonComponent } from '../../button/button.component';
import { DialogContentComponentBase, DialogContentViewModel } from '../../dialog/dialog-content-base';
import { DialogContentComponentIns } from '../../dialog/dialog-content-ins.component';
import { DialogHeaderComponentIns } from '../../dialog/dialog-header-ins.component';
import { SortIconComponent } from '../../sort-icon/sort-icon.component';
import { OrderingDirection } from '../../utils/ordering-direction';
import { IconComponent } from '../../icon/icon.component';

export interface SortDataDialogComponentData {
    items: {
        label: string;
        value: unknown;
    }[];
    currentValue: unknown;
    direction: OrderingDirection;
    onChange(data: {value: unknown; direction: OrderingDirection}): void;
}

@Component({
    selector: 'skl-sort-data-dialog-component',
    templateUrl: './sort-data-dialog.component.html',
    styleUrls: ['./sort-data-dialog.component.scss'],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [DialogContentComponentIns, DialogHeaderComponentIns, NgClass, SortIconComponent, ButtonComponent, TranslatePipe, IconComponent]
})
export class SortDataDialogComponent extends DialogContentComponentBase<DialogContentViewModel, SortDataDialogComponentData> {
    public select(value: unknown): void {
        const direction = value === this.data.currentValue
            ? this.data.direction === OrderingDirection.Asc ? OrderingDirection.Desc : OrderingDirection.Asc
            : OrderingDirection.Asc;

        this.data.currentValue = value;
        this.data.direction = direction;

        this.data.onChange({value, direction});
    }

    public isCurrentValue(item: { value: unknown, label: string}) {
        return item.value === this.data.currentValue;
    }
}
